module.exports = __webpack_public_path__ + "static/media/kk_casino_logo.0c8fc696.svg";